import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
import _imports_0 from '../assets/images/logo.png';
const _hoisted_1 = { class: "header-section tw-bg-red" };
const _hoisted_2 = {
    key: 0,
    class: "preloader"
};
const _hoisted_3 = { class: "overlay" };
const _hoisted_4 = { class: "row d-flex" };
const _hoisted_5 = { class: "navbar navbar-expand-lg navbar-light !tw-flex-nowrap" };
const _hoisted_6 = { class: "container" };
const _hoisted_7 = { class: "tw-flex tw-items-center tw-gap-2" };
const _hoisted_8 = { class: "tw-hidden min-[992px]:tw-flex tw-items-center" };
const _hoisted_9 = { class: "tw-text-[#FFAB20] tw-text-base tw-font-medium" };
const _hoisted_10 = { class: "tw-flex tw-items-center tw-gap-2" };
const _hoisted_11 = { class: "tw-flex min-[992px]:tw-hidden tw-items-center" };
const _hoisted_12 = { class: "tw-text-[#FFAB20] tw-text-base tw-font-medium" };
const _hoisted_13 = {
    key: 0,
    class: "sidebar-wrapper"
};
const _hoisted_14 = { class: "sidebar-nav" };
const _hoisted_15 = { class: "sidebar-actions" };
const _hoisted_16 = { class: "header-action d-flex align-items-center max-un tw-gap-2" };
const _hoisted_17 = { key: 0 };
const _hoisted_18 = { class: "login_menu navbar-right nav-sign" };
const _hoisted_19 = { class: "login" };
const _hoisted_20 = { class: "login" };
const _hoisted_21 = { class: "tw-text-[#FFAB20] tw-text-base tw-font-medium" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_ProfilePopover = _resolveComponent("ProfilePopover");
    return (_openBlock(), _createElementBlock("header", _hoisted_1, [
        (_ctx.showPreloader)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[13] || (_cache[13] = [
                _createElementVNode("div", { class: "loader" }, [
                    _createElementVNode("span"),
                    _createElementVNode("span"),
                    _createElementVNode("span"),
                    _createElementVNode("span"),
                    _createElementVNode("span"),
                    _createElementVNode("span"),
                    _createElementVNode("span"),
                    _createElementVNode("span"),
                    _createElementVNode("span"),
                    _createElementVNode("span"),
                    _createElementVNode("span"),
                    _createElementVNode("span"),
                    _createElementVNode("span"),
                    _createElementVNode("span")
                ], -1)
            ])))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("nav", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_router_link, {
                                to: "/",
                                class: "navbar-brand"
                            }, {
                                default: _withCtx(() => _cache[14] || (_cache[14] = [
                                    _createElementVNode("img", {
                                        src: _imports_0,
                                        class: "header-logo-mobile",
                                        alt: "logo"
                                    }, null, -1)
                                ])),
                                _: 1
                            })
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", {
                                class: _normalizeClass(_ctx.user ? 'tw-mr-2 min-[992px]:tw-hidden' : 'tw-hidden')
                            }, [
                                _cache[15] || (_cache[15] = _createElementVNode("p", { class: "tw-text-white tw-text-center tw-text-xs" }, "Balance", -1)),
                                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.formattedBalance), 1)
                            ], 2),
                            (!_ctx.user?.username)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "login !tw-hidden max-[992px]:!tw-block !tw-text-white max-[330px]:!tw-text-sm !tw-px-6 max-[500px]:!tw-px-2 !tw-py-[9px]",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#loginMod",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.openPopup('login')))
                                }, " Sign In "))
                                : _createCommentVNode("", true),
                            (!_ctx.user?.username)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    class: "cmn-btn reg md:!tw-px-6 !tw-text-sm !tw-px-2.5 md:!tw-py-[9px] !tw-py-[4.5px] !tw-hidden max-[992px]:!tw-block max-[375px]:!tw-px-2",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#registerMod",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.openPopup('register')))
                                }, " Sign Up "))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(_ctx.user ? 'tw-mr-2 min-[992px]:tw-hidden' : 'tw-hidden')
                                }, [
                                    _cache[16] || (_cache[16] = _createElementVNode("p", { class: "tw-text-white tw-text-center tw-text-xs" }, "Balance", -1)),
                                    _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.formattedBalance), 1)
                                ], 2),
                                (!_ctx.user?.username)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "login !tw-hidden max-[992px]:!tw-block !tw-text-white max-[330px]:!tw-text-sm !tw-px-6 max-[500px]:!tw-px-2 !tw-py-[9px]",
                                        "data-bs-toggle": "modal",
                                        "data-bs-target": "#loginMod",
                                        onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.openPopup('login')))
                                    }, " Sign In "))
                                    : _createCommentVNode("", true),
                                (!_ctx.user?.username)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        class: "cmn-btn reg md:!tw-px-6 !tw-text-sm !tw-px-2.5 md:!tw-py-[9px] !tw-py-[4.5px] !tw-hidden max-[992px]:!tw-block max-[375px]:!tw-px-2",
                                        "data-bs-toggle": "modal",
                                        "data-bs-target": "#registerMod",
                                        onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.openPopup('register')))
                                    }, " Sign Up "))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("button", {
                                class: "navbar-toggler collapsed !tw-pl-0 !tw-text-white",
                                type: "button",
                                onClick: _cache[4] || (_cache[4] =
                                    //@ts-ignore
                                    (...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
                            }, _cache[17] || (_cache[17] = [
                                _createElementVNode("i", { class: "fas fa-bars" }, null, -1)
                            ]))
                        ]),
                        (_ctx.showSidebar)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "sidebar-overlay",
                                onClick: _cache[5] || (_cache[5] =
                                    //@ts-ignore
                                    (...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
                            }))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", {
                            class: _normalizeClass(["sidebar-drawer", {
                                    'sideBar-open': _ctx.showSidebar,
                                    '': !_ctx.showSidebar,
                                }])
                        }, [
                            (_ctx.showSidebar)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createElementVNode("button", {
                                        class: "close-btn !tw-text-white",
                                        onClick: _cache[6] || (_cache[6] =
                                            //@ts-ignore
                                            (...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
                                    }, " × "),
                                    _createElementVNode("ul", _hoisted_14, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredNavLinks, (link) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                key: link.label,
                                                class: "sidebar-item"
                                            }, [
                                                _createVNode(_component_router_link, {
                                                    to: link.to,
                                                    class: _normalizeClass(["sidebar-link", {
                                                            '!tw-text-[#FFAB20]': _ctx.isActive(link.route),
                                                            '!tw-text-white': !_ctx.isActive(link.route),
                                                        }])
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(link.label), 1)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["to", "class"])
                                            ]));
                                        }), 128))
                                    ]),
                                    _createElementVNode("div", _hoisted_15, [
                                        (!_ctx.user?.username)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                type: "button",
                                                class: "login !tw-px-6 !tw-py-[9px]",
                                                onClick: _cache[7] || (_cache[7] =
                                                    () => {
                                                        _ctx.openPopup('login');
                                                        _ctx.toggleSidebar();
                                                    })
                                            }, " Sign In "))
                                            : _createCommentVNode("", true),
                                        (!_ctx.user?.username)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                type: "button",
                                                class: "cmn-btn reg !tw-px-6 !tw-py-[9px]",
                                                onClick: _cache[8] || (_cache[8] =
                                                    () => {
                                                        _ctx.openPopup('register');
                                                        _ctx.toggleSidebar();
                                                    })
                                            }, " Sign Up "))
                                            : _createCommentVNode("", true),
                                        (_ctx.user?.username)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 2,
                                                type: "button",
                                                class: "cmn-btn reg !tw-px-6 !tw-py-[9px]",
                                                onClick: _cache[9] || (_cache[9] =
                                                    () => {
                                                        _ctx.openPopup('deposit');
                                                        _ctx.toggleSidebar();
                                                    })
                                            }, " Deposit "))
                                            : _createCommentVNode("", true),
                                        (_ctx.user?.username)
                                            ? (_openBlock(), _createBlock(_component_ProfilePopover, {
                                                key: 3,
                                                user: _ctx.user,
                                                logout: _ctx.logout
                                            }, null, 8, ["user", "logout"]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                            id: "navbar-content",
                            class: _normalizeClass([_ctx.user ? 'tw-justify-between' : '', "collapse navbar-collapse justify-content-end"])
                        }, [
                            _createElementVNode("ul", {
                                class: _normalizeClass([_ctx.user ? 'tw-w-full' : '', "navbar-nav ml-auto mb-2 mb-lg-0 tw-mr-[120px]"])
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredNavLinks, (link) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        key: link.label,
                                        class: "tw-text-white"
                                    }, [
                                        _createVNode(_component_router_link, {
                                            to: link.to,
                                            class: _normalizeClass(["nav-link tw-font-semibold tw-bg-transparent tw-px-2.5", {
                                                    '!tw-text-[#FFAB20]': _ctx.isActive(link.route),
                                                    '!tw-text-white': !_ctx.isActive(link.route),
                                                }])
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(link.label), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["to", "class"])
                                    ]));
                                }), 128))
                            ], 2),
                            _createElementVNode("div", _hoisted_16, [
                                (!_ctx.user?.username)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                        _createElementVNode("ul", _hoisted_18, [
                                            _createElementVNode("li", _hoisted_19, [
                                                _createElementVNode("span", {
                                                    class: "btn-4 yellow-btn",
                                                    onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.openPopup('register'))),
                                                    role: "button",
                                                    tabindex: "0"
                                                }, "Signup")
                                            ]),
                                            _createElementVNode("li", _hoisted_20, [
                                                _createElementVNode("span", {
                                                    class: "btn-4 pink-bg",
                                                    onClick: _cache[11] || (_cache[11] = ($event) => (_ctx.openPopup('login'))),
                                                    role: "button",
                                                    tabindex: "0"
                                                }, "Login")
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                    class: _normalizeClass(_ctx.user ? 'tw-block' : 'tw-hidden')
                                }, [
                                    _cache[18] || (_cache[18] = _createElementVNode("p", { class: "tw-text-white tw-text-center tw-text-xs" }, "Balance", -1)),
                                    _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.formattedBalance), 1)
                                ], 2),
                                (_ctx.user?.username)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        class: "cmn-btn reg !tw-px-6 !tw-py-[9px]",
                                        "data-bs-toggle": "modal",
                                        "data-bs-target": "#registerMod",
                                        onClick: _cache[12] || (_cache[12] = ($event) => (_ctx.openPopup('deposit')))
                                    }, " Deposit "))
                                    : _createCommentVNode("", true),
                                (_ctx.user?.username)
                                    ? (_openBlock(), _createBlock(_component_ProfilePopover, {
                                        key: 2,
                                        user: _ctx.user,
                                        logout: _ctx.logout
                                    }, null, 8, ["user", "logout"]))
                                    : _createCommentVNode("", true)
                            ])
                        ], 2)
                    ])
                ])
            ])
        ])
    ]));
}
